module.exports = __webpack_public_path__ + "static/media/micregen.5a0f0640.jpg";